import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Checkbox } from '@els/els-react--checkbox';

export default function GroupOfMoreCheckbox(props) {
  const { id: structureOptionsId, option, groupId, optionId, onCheckboxClick, disableIncludeAndMoreGroup } = props;
  const title = option.get('title');
  const checked = option.get('checked');

  return (
    <Checkbox
      className="group-of-more-checkbox"
      disabled={disableIncludeAndMoreGroup}
      checked={checked}
      onChange={() => {
        onCheckboxClick(structureOptionsId, groupId, optionId);
      }}
      label={title}
    />
  );
}

GroupOfMoreCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};
